import { Component, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { catchError, retry } from "rxjs/operators";

import { RestService } from "../rest.service";
import { sendingRegistrationData } from "../register/sendingRegistrationData";

// Importing CountryList from Internal folder
import countryLists from "../../assets/countryList/country.json";
import stateLists from "../../assets/countryList/state.json";
import cityLists from "../../assets/countryList/city.json";
import { PasswordUtils } from "../utils/password.utils";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.css"],
})
export class RegisterComponent implements OnInit {
  error: string;
  countries: any;
  countryId: number;
  states: any;
  stateList: [];
  stateId: number;
  cities: any;
  cityList: [];
  cityId: number;
  isValidate: boolean = false;
  errorInfo: boolean = false;
  licencesMonth: any = 0;
  licencesPrice: any = 0;
  errorType: string = "";
  pwdError: boolean = true;
  setRoleName: string = "";

  companyname: any = "";
  title: any = "";
  firstname: any = "";
  lastname: any = "";
  phone: any = "";
  alternatephone: any = "";
  streetaddress: any = "";
  country: number;
  state: number;
  city: number;
  zipcode: any = "";
  email: any = "";
  password: any = "";
  confirmpassword: any = "";
  timezone: any = "";
  timezoneoffset: any = "";
  licences: any = "";
  isLoading: boolean = false;
  isCompanyEmpty: boolean = false;
  isFirstnameEmpty: boolean = false;
  isLastnameEmpty: boolean = false;
  isPhoneEmpty: boolean = false;
  isStreetEmpty: boolean = false;
  isZipcodeEmpty: boolean = false;
  isEmailAddEmpty: boolean = false;
  isPasswordEmpty: boolean = false;
  isConformPwdEmpty: boolean = false;
  isTimeZoneEmpty: boolean = false;

  isSuccess: boolean = false;
  isFailure: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";

  constructor(
    private http: HttpClient,
    private _restService: RestService,
    private router: Router,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.countries = countryLists.country;
    this.states = stateLists.state;
    this.cities = cityLists;

    this._restService.timezone.subscribe(
      (t) => (
        (this.timezone = t.text),
        (this.timezoneoffset = t.offset),
        (this.isTimeZoneEmpty = false)
      )
    );

    console.warn = () => {};
  }

  onChangeCompanyname(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.companyname = ""),
        (this.isCompanyEmpty = true))
      : (this.isCompanyEmpty = false);
  }

  onChangeFirstname(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.firstname = ""),
        (this.isFirstnameEmpty = true))
      : (this.isFirstnameEmpty = false);
  }

  onChangeLastname(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.lastname = ""),
        (this.isLastnameEmpty = true))
      : (this.isLastnameEmpty = false);
  }

  onChangePhone(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""), (this.phone = ""), (this.isPhoneEmpty = true))
      : ((this.isPhoneEmpty = false),
        (this.phone = e.target.value.replace(/[^0-9]/g, "").trim()));
  }

  onChangeStreet(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.streetaddress = ""),
        (this.isStreetEmpty = true))
      : (this.isStreetEmpty = false);
  }

  onChangeZipcode(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.zipcode = ""),
        (this.isZipcodeEmpty = true))
      : (this.isZipcodeEmpty = false);
  }

  onChangeEmailAddress(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.email = ""),
        (this.isEmailAddEmpty = true))
      : (this.isEmailAddEmpty = false);
  }

  onChangePassword(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.password = ""),
        (this.isPasswordEmpty = true))
      : (this.isPasswordEmpty = false);
  }

  onChangeConformPassword(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.confirmpassword = ""),
        (this.isConformPwdEmpty = true))
      : (this.isConformPwdEmpty = false);
  }

  registerForm = this.formBuilder.group({
    companyname: ["", Validators.required],
    title: ["", Validators.required],
    firstname: ["", Validators.required],
    lastname: ["", Validators.required],
    phone: ["", Validators.required],
    alternatephone: ["", Validators.nullValidator],
    streetaddress: ["", Validators.required],
    country: ["", Validators.required],
    state: ["", Validators.required],
    city: ["", Validators.required],
    zipcode: ["", Validators.required],
    timezone: ["", Validators.required],
    email: ["", [Validators.required, Validators.email]],
    password: ["", Validators.required],
    confirmpassword: ["", Validators.required],
    licences: ["", Validators.required],
  });

  allowingOnlyNumber(e: any) {
    e.target.value = e.target.value.replace(/[^0-9]/g, "").trim();
  }

  allowingOnlyAlphaNumber(e: any) {
    e.target.value = e.target.value
      .split(/[^a-zA-Z0-9 ]/)
      .join("")
      .replace(/\s/g, "")
      .trim();
  }

  removingBlankSpace(e: any) {
    e.target.value.substring(0, 1) === " " ? (e.target.value = "") : "";
  }

  checkPasswordRules(e: any) {
    this.pwdError = PasswordUtils.checkPasswordRules(e.target.value);
  }

  comparePassword(e: any) {
    this.password !== this.confirmpassword
      ? ((this.pwdError = false),
        (this.confirmpassword = ""),
        (this.isFailure = true),
        (this.failureMessage = "Password is not matching"))
      : (this.pwdError = true);
  }

  sendRegisterData(
    companyname: string,
    title: string,
    firstname: string,
    lastname: string,
    phone: string,
    alternatephone: string,
    streetaddress: string,
    country: number,
    state: number,
    city: number,
    zipcode: string,
    email: string,
    password: string,
    timezone: string,
    licences: any
  ) {
    console.log("Timezone", this.timezone);

    var decimal = /^(?=.*\d)(?=.*[@$!%*?&])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,50}$/;
    password.match(decimal) ? (this.pwdError = true) : (this.pwdError = false);

    this.companyname === ""
      ? (this.isCompanyEmpty = true)
      : (this.isCompanyEmpty = false);
    this.firstname === ""
      ? (this.isFirstnameEmpty = true)
      : (this.isFirstnameEmpty = false);
    this.lastname === ""
      ? (this.isLastnameEmpty = true)
      : (this.isLastnameEmpty = false);
    this.phone === ""
      ? (this.isPhoneEmpty = true)
      : (this.isPhoneEmpty = false);
    this.streetaddress === ""
      ? (this.isStreetEmpty = true)
      : (this.isStreetEmpty = false);
    this.zipcode === ""
      ? (this.isZipcodeEmpty = true)
      : (this.isZipcodeEmpty = false);
    this.email === ""
      ? (this.isEmailAddEmpty = true)
      : (this.isEmailAddEmpty = false);
    this.password === ""
      ? (this.isPasswordEmpty = true)
      : (this.isPasswordEmpty = false);
    this.confirmpassword === ""
      ? (this.isConformPwdEmpty = true)
      : (this.isConformPwdEmpty = false);
    this.timezone === undefined
      ? (this.isTimeZoneEmpty = true)
      : (this.isTimeZoneEmpty = false);

    this.isValidate = true;

    if (
      this.pwdError === true &&
      this.companyname !== "" &&
      this.firstname !== "" &&
      this.lastname !== "" &&
      this.phone !== "" &&
      this.streetaddress !== "" &&
      this.zipcode !== "" &&
      this.email !== "" &&
      this.password !== "" &&
      this.confirmpassword !== "" &&
      this.timezone !== undefined &&
      this.countryId !== undefined &&
      this.stateId !== undefined &&
      this.cityId !== undefined
    ) {
      this.errorInfo = true;
      this.isLoading = true;

      var reg = new sendingRegistrationData();
      reg.companyName = companyname;
      reg.gender = title;
      reg.firstName = firstname;
      reg.lastName = lastname;
      reg.phone = phone;
      reg.altPhone = alternatephone;
      reg.streetAddress = streetaddress;
      reg.country = this.countryId;
      reg.state = this.stateId;
      reg.city = this.cityId;
      reg.zipcode = zipcode;
      reg.email = email;
      reg.passWord = PasswordUtils.encryptPassword(password);
      reg.timeZone = this.timezone;
      reg.totalLicences = licences;
      reg.timeZoneOffset = this.timezoneoffset;

      this._restService
        .registrationCondition(reg)
        .pipe(
          catchError((e) => {
            console.log("err --->", e);
            this.isLoading = false;
            this.isFailure = true;
            this.failureMessage = e.error.StatusInfo;
            return e;
          })
        )
        .subscribe(
          (data: any) => (
            (this.isSuccess = true),
            (this.successMessage = data.StatusInfo),
            (this.isLoading = false),
            (this.timezone = "")
          )
        );
    } else {
      this.errorInfo = false;
      this.isValidate = true;
    }
  }

  onChangeCountryEvent(cid: any) {
    this.countryId = parseInt(cid);
    var st = this.states[cid];
    this.stateList = st;
  }

  onChangeStateEvent(sid: any) {
    this.stateId = parseInt(sid);
    var cl = this.cities.city[sid];

    this.cityList =
      cl === undefined
        ? [
            {
              id: "000",
              name: "No City",
              state_id: "000",
            },
          ]
        : cl;
  }

  onChangeCityEvent(ctid: any) {
    this.cityId = parseInt(ctid);
  }

  onChangeLicences(e: any, c: any) {
    let sum: any = c * 1;
    this.licencesMonth = c;
    this.licencesPrice = sum;
  }

  removingMinus(e: any) {
    e.which === 109 ||
    e.which === 189 ||
    e.which === 173 ||
    e.target.value === "0"
      ? (e.target.value = "")
      : "";
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
    this.router.navigate([""]);
  }
}
